module.exports = __webpack_public_path__ + "img/avatar-13.971fdbcf.jpg";